"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var BasicIcon_1 = __importDefault(require("../../../../../../components/common/BasicIcon"));
var FormComponent_1 = __importDefault(require("../../../../../../components/FormComponents/FormComponent"));
var schemaSlice_1 = require("../../../../../../features/post/schemaSlice");
var schemaHelper_1 = require("../../../../../../helpers/schemaHelper");
var postSlice_1 = require("../../../../../../features/post/postSlice");
var globalSlice_1 = require("../../../../../../features/global/globalSlice");
var react_redux_1 = require("react-redux");
var PostTabsContext_1 = require("../../../../../../contexts/PostTabsContext");
var usePrevious_1 = require("../../../../../../hooks/usePrevious");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var SimpleCard = function (_a) {
    var _b;
    var step = _a.step, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded, reorderMedia = _a.reorderMedia;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var tabRef = react_1.useRef(null);
    var handleTabPositionChange = react_1.useContext(PostTabsContext_1.PostTabsContext).handleTabPositionChange;
    var previousData = usePrevious_1.usePrevious(formikProps.values.initial_info.property_type);
    react_1.useEffect(function () {
        if (tabRef.current && rows) {
            handleTabPositionChange(name, tabRef.current.offsetTop, tabRef.current.offsetTop + tabRef.current.offsetHeight);
        }
    }, [isLoaded, (_b = tabRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop]);
    react_1.useEffect(function () {
        previousData !== formikProps.values.initial_info.property_type &&
            dispatch(schemaSlice_1.setCurrentPropertyType(formikProps.values.initial_info.property_type));
    }, [formikProps.values.initial_info.property_type]);
    var rows = step.fields.rows, order = step.order, name = step.name;
    if (!rows) {
        return null;
    }
    var id = post.id;
    var validatedRows = schemaHelper_1.excludeFieldsByCondition(rows, formikProps.values);
    var uploadMedia = function (id, files) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.uploadBuildingMedia(id, files))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_1.response.data.errors[key]
                            ? t('ERRORS.' + e_1.response.data.errors[key][0])
                            : t('ERRORS.IMAGE_UPLOAD_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { ref: tabRef },
        react_1.default.createElement("div", { className: classnames_1.default('element form-section card', styles_module_scss_1.default.card), key: order },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_header },
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.header_title },
                        react_1.default.createElement(BasicIcon_1.default, { iconClass: step.icon }),
                        react_1.default.createElement("h3", null, t(name)))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_content },
                    react_1.default.createElement("div", { className: "ui grid stackable form" }, validatedRows.map(function (row, i) {
                        return (react_1.default.createElement("div", { className: "equal width row", key: i }, Object.keys(row).map(function (fieldName) {
                            var field = row[fieldName];
                            return (react_1.default.createElement(FormComponent_1.default, { key: fieldName, field: field, fieldName: fieldName, order: order, section: name, formikProps: formikProps, disabled: field.disabled, isDisableWhenRental: field.isDisableWhenRental, onMediaUpload: function (files) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, uploadMedia(id, files)];
                                            case 1: return [2 /*return*/, _a.sent()];
                                        }
                                    });
                                }); }, onMediaReorder: function (from, to) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        reorderMedia(id, from, to);
                                        return [2 /*return*/];
                                    });
                                }); } }));
                        })));
                    })))))));
};
exports.default = SimpleCard;
